import React,{useMemo,useState} from "react";
import { useTable,useRowSelect } from 'react-table';
import axios from "axios";
import {MakeExcelFileForDownload,CloseExcelPopup,IndeterminateCheckbox,ToggleDarkBackground,PassedMonths,ChangeSimpleDateString,isNull} from "../../../components/common/Common";
import AnalysisMamamonte from "./AnalysisMamamonte";
import AnalysisFly from "./AnalysisFly";
import removeIcon from "../../../img/icon/icon-circle-minus.svg";

const AnalysisSearchResult = ({varTotalCount,varColumnLists,varAnalysisLists,varSearchData}) => {
  //컬럼 - 제목부
  const columns = useMemo(() => {
    return varColumnLists; 
    // eslint-disable-next-line
  },[varColumnLists]);

  //표시할 정보
  const data = useMemo(() => {
    return varAnalysisLists;
    // eslint-disable-next-line
  }, [varAnalysisLists]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow,selectedFlatRows} 
    = useTable({ columns, data, initialState:{hiddenColumns:["cl_idx","ch_idx","cl_type"]}},useRowSelect, 
      hooks => {
        hooks.visibleColumns.push(columns => [
          {
            id: 'selection',
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <div style={{width:"20px"}}>
                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
              </div>
            ),
            Cell: ({ row }) => (
              <div style={{width:"40px"}}>
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
              </div>
            )
          },
          ...columns,
        ])
      }
  );

  const [varShowMammonte,setShowMammonte] = useState(false);
  const [varShowFly,setShowFly] = useState(false);
  const [varItemInfo,setItemInfo] = useState({});

  //발달 진도표 
  const onAnalisysDetailHandler = (e,values) => {
    const cl_type = values.cl_type;
    setItemInfo(values);
    ToggleDarkBackground(true);
    if(cl_type === 1) { //마마몽떼
      setShowMammonte(true);
    } else {  //플라이
      setShowFly(true);
    }
  }
  const onClosePopupHandler = (cl_type) => {
    ToggleDarkBackground(false);
    if(cl_type === 1) { //마마몽떼
      setShowMammonte(false);
    } else {  //플라이
      setShowFly(false);
    }
  }

  //엑셀 다운로드--------------------------------------------------------
  //엑셀다운 범위 선택창 표시
  const onSelectDownloadModeHandler = (e) => {
    const popupWin = document.querySelector('.excel-buttons');
    if(popupWin.classList.contains('hide')) popupWin.classList.remove('hide');
  }
  //엑셀로 다운로드 방식 선택후
  const onDownloadExcelHandler = (e,imode) => {
    var iselected = selectedFlatRows.length;
    console.log(iselected);
    const popupWin = document.querySelector('.excel-buttons');
    if(!popupWin.classList.contains('hide')) popupWin.classList.add('hide');
    if(imode === 1) MakeExcelFileForDownload(varColumnLists,varAnalysisLists,'발달분석 및 평가');
    else ReadAllLists();
  } 
  //전체페이지 정보 읽기
  const ReadAllLists = async() => {
    const sendData = {pageNum: 0,pageSize: 0,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_classes_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let newArray = [];
        const pmax = datas.totalcount;
        if(datas.results?.length > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['ch_name'] = lineObj.ch_name;
            newData['ch_month'] = PassedMonths(lineObj.ch_birthday)+" 개월";
            newData['ch_birthday'] = ChangeSimpleDateString(lineObj.ch_birthday);
            newData['evaluation'] = lineObj.cl_type===1?"마마몽떼":"플라이";
            newData['semester_class'] = lineObj.sm_name+' '+lineObj.cl_name;
            newData['studies'] = (isNull(lineObj.pass_cnt)?0:lineObj.pass_cnt)+'/'+lineObj.cl_studys;
            newData['evaluation_date'] = ChangeSimpleDateString(lineObj.clc_adate);
            newData['cl_idx'] = lineObj.cl_idx;
            newData['ch_idx'] = lineObj.ch_idx;
            newData['cl_type'] = lineObj.cl_type;
            newArray.push(newData);
          }
        }
        MakeExcelFileForDownload(varColumnLists,newArray,'발달분석 및 평가');
      }
    });
  }

  //삭제
  /* const onDeleteSuggestListHandler = async(e) => {
    var iselected = selectedFlatRows.length;
    if(iselected === 0) {
      alert(`삭제할 정보가 선택되어 있지 않습니다.`);
      return false;
    }
    let memIndexString = "";
    for(var i=0; i < iselected; i++) {
      var sline = selectedFlatRows[i].values['cnr_idx'];
      memIndexString = AddOptionToString(sline,memIndexString,',');
    }
    if (!window.confirm(`${iselected}개의 선택된 정보를 삭제합니까?`)) return false;
    const sendData = {delitems: memIndexString};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_delete_analysis_list`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        ReadProductLists();
      } else {
        alert(res.data.message);
      }
    });    
  } */

  return (
    <div className="main-box" style={{marginTop:"30px",padding:"0px 10px"}}>
      <div className="btn-right">
        <div><label htmlFor="tcount">검색건수</label>&nbsp;<span id="tcount">{varTotalCount}</span>&nbsp;건</div>&nbsp;&nbsp;&nbsp;
        {varAnalysisLists.length===0?null:
          <div className="excel-area">
            <button onClick={e=>onSelectDownloadModeHandler(e)} className="btn line">엑셀다운로드</button>
            <div className="excel-buttons hide">
              <button onClick={e=>onDownloadExcelHandler(e,1)}>현재페이지</button>
              <button onClick={e=>onDownloadExcelHandler(e,0)}>전체</button>
              <img src={removeIcon} alt="" className="excel-close-button" onClick={()=>CloseExcelPopup()}/>
            </div>
          </div>
        }
      </div>
      <div className="scroll-table" style={{border:"solid 1px #ccc",marginBottom:"10px"}}>
        <table className="list scroll delivery" {...getTableProps()}>
          {varColumnLists?.length===0?<thead></thead>:
            <thead>
              {headerGroups.map((headerGroup) => {
                const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
                return (
                  <tr key={key} {...restHeaderGroupProps}>
                    {headerGroup.headers.map((column,ii) => {
                      const { key, ...restColumn } = column.getHeaderProps({style:{width:ii===0?40:column.width}});
                      return (<th key={key} {...restColumn}>{column.render('Header')}</th>);
                    })}
                    <th style={{width:"90px"}}>상세</th>
                  </tr>
                )
              })}
            </thead>
          }
          {varAnalysisLists?.length===0?<tbody><tr><td colSpan={11}>등록된 발달분석 및 평가가 없습니다.</td></tr></tbody>:
            <tbody {...getTableBodyProps()}>
              {rows.map((row,i) => {
                prepareRow(row);
                const { key, ...restRowGroupProps } = row.getRowProps();
                return (
                  <tr key={key} {...restRowGroupProps}>
                    {row.cells.map((cell,i) => {
                      const { key, ...restCellProps } = cell.getCellProps();
                      return (<td key={key} {...restCellProps}>{cell.render('Cell')}</td>);
                    })}
                    <td>
                      <button style={{width:"80px"}} className="btn line black" onClick={e=>onAnalisysDetailHandler(e,row.values)}>상세</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          }
        </table>
      </div>
      <AnalysisMamamonte varShowMammonte={varShowMammonte} onClosePopupHandler={onClosePopupHandler} varItemInfo={varItemInfo}/>
      <AnalysisFly varShowFly={varShowFly} onClosePopupHandler={onClosePopupHandler} varItemInfo={varItemInfo}/>
    </div>
  )
}
export default AnalysisSearchResult;